// extracted by mini-css-extract-plugin
export default {"ChallengesScreen":"ChallengesScreen_ChallengesScreen__1ufoU","wrapper":"ChallengesScreen_wrapper__EA4u-","oppCardWrapper":"ChallengesScreen_oppCardWrapper__JPLQl"};